<template>
  <v-app id="inspire">
    <div class="completed-jobs-reports-wrap">
      <v-layout class="inv-top-header mb-4">
        <v-flex>
          <p class="text-uppercase caption mb-0">Reports</p>
          <h2 class="headline">Residential Cross-Sells Report</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 mb-0 mt-2"
          text
          small
          :disabled="loading || items.length === 0"
          @click="exportCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
        >
      </v-layout>

      <v-flex class="header-search-single">
        <v-container class="grid-list-md pa-0 mb-4 container--fluid">
          <v-layout class="wrap xs12">  
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu1"
                :label="`From Date`"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="tebleData.date_from"
                    :label="`From Date`"
                    persistent-hint
                    prepend-icon="event"
                    placeholder="Please Select"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tebleData.date_from"
                  no-title
                  :min="minDate"
                  :max="maxDate"
                  @input="menu1 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu2"
                :label="`To Date`"
                v-model="menu2"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="tebleData.date_to"
                    :label="`To Date`"
                    persistent-hint
                    prepend-icon="event"
                    placeholder="Please Select"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tebleData.date_to"
                  no-title
                  :min="minDate"
                  :max="maxDate"
                  @input="menu2 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-autocomplete
                :items="staff"
                v-model="tebleData.assigned_to"
                label="Field Tech"
                item-text="name"
                item-value="id"
                clearable
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-autocomplete
                :items="clients"
                v-model="tebleData.client_id"
                label="Client Name"
                :item-text="i => `${i.first_name} ${i.last_name}`"
                item-value="id"
                clearable
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-autocomplete
                :items="services"
                v-model="tebleData.cross_sell_id"
                label="Cross-Sell"
                item-text="name"
                item-value="id"
                clearable
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-btn
                large
                color="primary"
                dark
                class="mx-0 mt-1 mb-2"
                style="min-width: 50px; padding: 0 10px;"
                @click="initialize"
              >
                Apply
              </v-btn>
            </v-flex>
            <v-flex class="xs12 pa-0">
              <v-alert class="pa-2 mt-2" :value="!no_data.includes(dateError)" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">{{ dateError }}</span>
              </v-alert>
            </v-flex>
            <v-flex class="xs12 my-0">
              <span
                @click="resetFilters"
                class="clear-filters"
                >Reset Filters</span
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :disable-pagination="true"
          :loading="loading"
          loader-height="2"
          hide-default-footer
          class="elevation-1 table-org"
          :class="{'table-completed': !(loading)}"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <span v-if="!no_data.includes(item.date)">{{ item.date }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout v-if="!no_data.includes(item.first_name)" style="margin-left: -14px;">
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/client/${item.client_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.first_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout v-if="!no_data.includes(item.last_name)" style="margin-left: -14px;">
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/client/${item.client_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.last_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.address)">{{ item.address }}<span v-if="!no_data.includes(item.city)">, {{ item.city }}</span>
                </span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout v-if="!no_data.includes(item.assigned_to_name)" style="margin-left: -14px;">
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/staff/${item.assigned_to_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                          View Field Tech Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.assigned_to_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout v-if="!no_data.includes(item.cross_sell_name)" style="margin-left: -14px;">
                  <v-menu v-if="!no_data.includes(item.cross_sell_id)" bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/residential_cross_sell/${item.cross_sell_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                          View Cross-Sell Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.cross_sell_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.quantity)">{{ item.quantity }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="addResServReport()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <template v-if="totalData.length > 0">
        <h2 class="title mt-5 mb-3">Total Quantity per Cross-Sell</h2>
        <v-card>
          <v-data-table
            :headers="totalHeaders"
            :items="totalData"
            :disable-pagination="true"
            :loading="loading"
            loader-height="2"
            hide-default-footer
            class="elevation-1 table-org"
            mobile-breakpoint="100"
          >
            <template v-slot:item="{item}">
              <tr class="items-body-row">
                <td>
                  <v-layout v-if="!no_data.includes(item.name)" :style="{marginLeft: !no_data.includes(item.cross_sell_id) ? '-14px' : '0'}">
                    <v-menu v-if="!no_data.includes(item.cross_sell_id)" bottom right d-inline-flex>
                      <template v-slot:activator="{ on }">
                        <v-btn class="ma-0" v-on="on" icon>
                          <v-icon color="#999">more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list class="pa-0">
                        <v-list-item
                          @click="$router.push(`/residential_cross_sell/${item.cross_sell_id}/show`)"
                        >
                          <v-flex class="body-1">
                            <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                            View Cross-Sell Details
                          </v-flex>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-layout class="wrap align-center">
                      <v-flex>{{ item.name }}</v-flex>
                    </v-layout>
                  </v-layout>
                  <em v-else class="grey--text">No data</em>
                </td>
                <td>
                  <span v-if="!no_data.includes(item.quantity_total)">{{ item.quantity_total }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
            </template>
            <template
              slot="no-data"
              v-if="error_code == 404 || error_code == 500"
            >
              <v-btn color="primary" @click="addResServReport()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import moment from "moment";
import { preciseMultiply, preciseDivide } from "@/common/preciseMath";
import {mapGetters} from "vuex"

export default {
  name: "ResidentialCrossSellsReport",
  data: () => ({
    menu1: false,
    menu2: false,
    no_data: [null, "", undefined, "null"],
    headers: [
      { 
        text: "Date", 
        value: "date", 
        align: "left", 
      },
      {
        text: "Client First Name",
        value: "first_name",
        align: "left", 
      },
      {
        text: "Client Last Name",
        value: "last_name",
        align: "left",
      },
      {
        text: "Address",
        value: "address",
        sortable: false,
        align: "left",
      },
      {
        text: "Field Tech",
        value: "assigned_to_name",
        align: "left",
      },
      {
        text: "Cross-Sell",
        value: "cross_sell_name",
        align: "left",
      },
      {
        text: "Quantity",
        value: "quantity",
        align: "left",
      }
    ],
    totalHeaders: [
      {
        text: "Cross-Sell",
        value: "name",
        align: "left",
      },
      {
        text: "Total Quantity",
        value: "quantity_total",
        align: "left",
      }
    ],
    items: [],
    tebleData: {
      date_from: moment().subtract(7, "d").format("YYYY[-]MM[-]DD"),
      date_to: moment().format("YYYY[-]MM[-]DD"),
    },
    clients: [],
    clientsLoading: false,
    staff: [],
    services: [],
    staffLoading: false,
    servicesLoading: false,
    loadedFromDate: null,
    loadedToDate: null,
    loadedFieldTech: null,
    loadedClient: null,
    loading: false,
    addResServReportLoadin: false,
    error_code: ""
  }),
  mounted() {
    this.initialize()
    this.getClientList()
    this.getStaffList()
    this.getAllServices()
  },
  methods: {
    log(i) {
      console.log(i)
    },
    initialize() {
      if(this.no_data.includes(this.dateError)) {
        this.loading = true
        this.addResServReport()
          .then(values => {
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      }
    },
    addResServReport() {
      if(this.no_data.includes(this.dateError)) {
        this.addResServReportLoadin = true;
        return new Promise((resolve, reject) => {
          let body = {
            organization_id: this.user.organization_id,
            ...this.tebleData
          };
  
          ApiService.get("/scheduler/additional_services_report", body)
            .then(response => {
              this.items = response.data.additional_services.filter(i => 
                !this.no_data.includes(i.cross_sell_name) &&
                !this.no_data.includes(i.quantity)
              )
              this.loadedFromDate = body.date_from
              this.loadedToDate = body.date_to
              if(body.assigned_to) {
                this.loadedFieldTech = this.staff.find(i => i.id === body.assigned_to).name
              } else {
                this.loadedFieldTech = null
              }
              if(body.client_id) {
                let client = this.clients.find(i => i.id === body.client_id)
                this.loadedClient = `${client.first_name} ${client.last_name}`
              } else {
                this.loadedClient = null
              }
              this.addResServReportLoadin = false;
              resolve()
            })
            .catch(error => {
              this.items = []
              this.addResServReportLoadin = false;
              reject()
            });
        })
      }
    },
    resetFilters() {
      this.tebleData.date_from = moment().subtract(7, "d").format("YYYY[-]MM[-]DD")
      this.tebleData.date_to = moment().format("YYYY[-]MM[-]DD")
      delete this.tebleData.assigned_to
      delete this.tebleData.client_id
      delete this.tebleData.cross_sell_id
      this.initialize()
    },
    getClientList() {
      this.clientsLoading = true
      ApiService.get("/client/list", { statuses: ['active', 'inactive']})
        .then(response => {
          let data = response.data;
          this.clients = data.clients;
          this.clientsLoading = false
        })
        .catch(erorr => {
          console.log(error);
          this.clientsLoading = false
        });
    },
    getStaffList() {
      this.staffLoading = true
      ApiService.get("/employee_select_list")
        .then(res => {
          this.staff = res.data.staff
          this.staffLoading = false
        })
        .catch(err => {
          console.log(err)
          this.staffLoading = false
        });
    },
    getAllServices() {
      this.servicesLoading = true
      ApiService.get("/client/details/list_cross_sells")
        .then(response => {
          this.services = response.data.cross_sells
          this.servicesLoading = false
        })
        .catch(error => {
          console.log(error)
          this.servicesLoading = false
        });
    },
    exportCSV() {
      let csvContent = "";
      let headers = [];
      let csvData = [];
      this.headers.forEach(i => {
        if (i.text != "Actions") {
          headers.push(i.text);
        }
      });
      headers.map(i => `"${i}"`);
      this.items.forEach(i => {
        let row = {
          date: !this.no_data.includes(i.date)
            ? `"${i.date}"`
            : `""`,
          first_name: !this.no_data.includes(i.first_name)
            ? `"${i.first_name}"`
            : `""`,
          last_name: !this.no_data.includes(i.last_name)
            ? `"${i.last_name}"`
            : `""`,
          address: !this.no_data.includes(i.address)
            ? `"${i.address}${!this.no_data.includes(i.city) ? ', ' + i.city : ''}"`
            : `""`,
          assigned_to_name: !this.no_data.includes(i.assigned_to_name)
            ? `"${i.assigned_to_name}"`
            : `""`,
          cross_sell_name: !this.no_data.includes(i.cross_sell_name)
            ? `"${i.cross_sell_name}"`
            : `""`,
          quantity: !this.no_data.includes(i.quantity)
            ? `"${i.quantity}"`
            : `""`,
        };
        csvData.push(row);
      });

      csvContent += [
        headers.join(","),
        ...csvData.map(item => Object.values(item).join(","))
      ].join("\n").replace(/(^\[)|(\]$)/gm, "");

      if(this.totalData.length > 0) {
        let totalHeaders = []
        let totalCsvData = []
        totalHeaders = this.totalHeaders.map(i => `"${i.text}"`)
        this.totalData.forEach(i => {
          let row = {
            name: !this.no_data.includes(i.name)
              ? `"${i.name}"`
              : `""`,
            quantity_total: !this.no_data.includes(i.quantity_total)
              ? `"${i.quantity_total}"`
              : `""`,
          };
          totalCsvData.push(row);
        })
        csvContent += [
          "\n",
          totalHeaders.join(","),
          ...totalCsvData.map(item => Object.values(item).join(","))
        ].join("\n").replace(/(^\[)|(\]$)/gm, "");
      }

      const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(data)
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Residential Cross-Sells Report - from ${this.loadedFromDate} to ${this.loadedToDate}${
          !this.no_data.includes(this.loadedFieldTech) ? ' - ' + this.loadedFieldTech : ''
          }${
          !this.no_data.includes(this.loadedClient) ? ' - ' + this.loadedClient : ''
          }.csv`
      );
      link.click();
    },
    titleDateFormat() {
      return `${this.loadedFromDate} - ${this.loadedToDate}`
    },
    multiply(a, b) {
      return preciseMultiply(a, b)
    },
    divide(a, b) {
      return preciseDivide(a, b)
    },
  },
  computed: {
    ...mapGetters(["user"]),
    minDate: function() {
      return moment().subtract(1, "y").format('YYYY[-]MM[-]DD')
    },
    maxDate: function() {
      return moment().format('YYYY[-]MM[-]DD')
    },
    dateError: function() {
      let error = ''
      if(this.no_data.includes(this.tebleData.date_from) || this.no_data.includes(this.tebleData.date_to)) {
        error = 'From Date and To Date fields are required'
      } else if (moment(this.tebleData.date_from).isAfter(moment(this.tebleData.date_to))) {
        error = 'From Date must be before To Date. Please correct selected dates.'
      } else {
        error = ''
      }
      return error
    },
    totalData: function() {
      let groupedItems = []
      let output = []
      if(this.items.length > 0) { 
        groupedItems = _.groupBy(this.items, "cross_sell_id")
        Object.values(groupedItems).forEach(i => {
          let name = null
          let quantity_total = 0
          let cross_sell_id = null
          if(i.some(s => !this.no_data.includes(s.cross_sell_name))) {
            name = i.reverse().find(s => !this.no_data.includes(s.cross_sell_name)).cross_sell_name
          }
          if(i.some(s => !this.no_data.includes(s.cross_sell_id))) {
            cross_sell_id = i.find(s => !this.no_data.includes(s.cross_sell_id)).cross_sell_id
          }
          i.forEach(el => {
            if (
              !this.no_data.includes(el.quantity) &&
              typeof parseFloat(el.quantity) === "number"
            ) {
              quantity_total += parseFloat(el.quantity);
            }
          })
          if(name !== null) {
            output.push({name, quantity_total, cross_sell_id})
          }
        })
      }
      return output 
    }
  }
};
</script>
<style>

.completed-jobs-reports-wrap .header-search-single {
  padding-bottom: 20px;
}

.completed-jobs-reports-wrap td a {
  text-decoration: none;
}

.completed-jobs-reports-wrap .clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
}

.completed-jobs-reports-wrap .table-head-text {
  white-space: normal;
  text-align: left;
  min-width: 100px;
}

.completed-jobs-reports-wrap .job-status-missed {
  color: red;
}
.completed-jobs-reports-wrap .job-status-completed,
.completed-jobs-reports-wrap .job-status-started {
  color: forestgreen;
}
.completed-jobs-reports-wrap .job-status-pending {
  color: #9e9e9e;
}
.completed-jobs-reports-wrap .job-status-skipped {
  color: #2196f3;
}
.completed-jobs-reports-wrap .job-status-dispatched {
  color: orange;
}

.completed-jobs-reports-wrap .job-status-text {
  text-transform: uppercase;
}

</style>
